import React from "react";
import badge from '../../../../assets/appchallengecenter/badge.jpg';
import glimpseBar from '../../../../assets/appchallengecenter/glimpseBar.jpg';
import push_bg from '../../../../assets/appchallengecenter/push_bg.jpg';
import ChallengeLegend from "./ChallengeLegend";
import { PartnerLogoBox } from "./PartnerLogoBox";
import Complex from "./challengetypes/Complex";

import ReactMarkdown from 'react-markdown';
import MarkdownHelper from '../../../utils/MarkdownHelper';
import { classNames } from "../../../utils/classNames";
import { match } from "../../../utils/match";

const AppChallengeCenter = props => {
    const bg = props.challengeValues['challenge_hintergrund'] ? props.challengeValues['challenge_hintergrund'].toLowerCase() : undefined
    const backgroundImageType = match(bg, [
        ['blau', 'blue'],
        ['grau', 'grey'],
        ['hon', 'hon'],
        ['sen', 'sen'],
        ['ftl', 'ftl'],
        ['bild hell', 'custom-dark'],
        ['bild dunkel', 'custom-light'],
    ], () => 'blue')

    // 374px * 230px safe area
    const backgroundImageUrl = props.challengeValues["challenge_hintergrundbild-url"]
    const backgroundImageStyle = (['custom-light', 'custom-dark'].includes(backgroundImageType) && backgroundImageUrl) ? `url('${backgroundImageUrl}')` : undefined

    const detailViewLegendItems = [
        ["Announcement", props.challengeValues.challenge_announcement || ""],
        ["Available", props.challengeValues.challenge_available],
        ["Activated", props.challengeValues.challenge_activated],
        ["Task successfull - awaiting reward*", props.challengeValues["challenge_task-successful-awaiting-reward"]],
        ["Task successfull - reward credited*", props.challengeValues["challenge_task-successful-reward-credited"]],
        ["Task not successfull - activity cancelled*", props.challengeValues["challenge_task-not-successful-activity-cancelled"]],
        ["Challenge successfull - awaiting reward*", props.challengeValues["challenge_challenge-successful-awaiting-reward"]],
        ["Challenge successfull - reward credited*", props.challengeValues["challenge_challenge-successful-reward-credited"]],
        ["Challenge not successfull*", props.challengeValues["challenge_challenge-ended-not-completed"]],
        ["Challenge not successfull - activity cancelled*", props.challengeValues["challenge_challenge-ended-activity-cancelled"]],
        ["Challenge not successfull - activity pending", props.challengeValues["challenge_challenge-ended-activity-pending"]],
        ["Ending soon - activated*", props.challengeValues["challenge_challenge-ending-soon-activated"]],
        ["Ended - never activated*", props.challengeValues["challenge_challenge-ended-never-activated"]]
    ];
    const successOverlaysLegendItems = [
        ["Task 1 success text*", props.challengeValues["challenge_task-1-success-text"]],
        ["Task 2 success text*", props.challengeValues["challenge_task-2-success-text"]],
        ["Task 3 success text*", props.challengeValues["challenge_task-3-success-text"]],
        ["Task 4 success text*", props.challengeValues["challenge_task-4-success-text"]],
        ["Task 5 success text*", props.challengeValues["challenge_task-5-success-text"]],
        ["Task 6 success text*", props.challengeValues["challenge_task-6-success-text"]],
        ["Challenge success text*", props.challengeValues["challenge-success-text"]]
    ];
    const pushnotificationsLegendItems = [
        ["New challenge available*", props.challengeValues["challenge_notification-new-challenge-available"]],
        ["Task/Challenge successfull - reward credited*", props.challengeValues["challenge_notification-taskchallenge-successful-reward-credited"]],
        ["Challenge ending soon*", props.challengeValues["challenge_notification-challenge-ending-soon"]]
    ];

    const renderChallengeTeaser = (
        <div className="app-spacers">
            <div className="app-view mb-md">
                <h2 className="component-headline no-page-break">Challenge Teaser</h2>
                <div className="teaser-container">
                    <img className="img-fluid" src={glimpseBar} alt="" />
                    <div className="teaser-img-text">
                        {props.challengeValues.challenge_name}
                    </div>
                    <div className="teaser-img-container">
                        <img className="teaser-img-logo" src={props.challengeValues["challenge_icon-link"]} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )

    const renderChallengeDetailView = (
        <div className="app-spacers">
            <h2 className="component-headline">Challenge Detail View</h2>
            <div className="challenge-detail-view">
                <div className="app-view mb-md">
                    <div className="detailview-img-container">
                        <div className={classNames('app-challenge-img-container', backgroundImageType)} style={{
                            '--background': backgroundImageStyle,
                        }}>
                            <Complex challengeValues={props.challengeValues} />
                        </div>
                        <PartnerLogoBox logos={props.challengeValues.challenge_partnerlogos} />

                        <div className="process-container no-margin">
                            <div className="process-container-title detailview-partner">
                                So funktioniert’s
                            </div>
                            {props.challengeValues["challenge_so-funktionierts"] ?
                                (<div className="process-container-so-funktionierts">
                                    <div className="no-margin">
                                        <ReactMarkdown {...MarkdownHelper.allTypes()} source={MarkdownHelper.parse(props.challengeValues["challenge_so-funktionierts"])} />
                                    </div>
                                </div>) : null}
                        </div>
                        <div className="process-container detailview-padding no-margin">
                            <div className="process-container-text">
                                <p className="no-margin">Teilnahmebedingungen</p>
                            </div>
                        </div>
                        <hr className="teilnahmebedingungen-hr" />
                        <div>
                            <div className="app-challenge-switch">
                                <label>
                                    <span className="app-challenge-switch__control" />
                                </label>
                            </div>
                            <div className="teilnahmebedingungen-text">
                                <span>{props.challengeValues["challenge_terms-conditions-confirmation"]}</span>
                            </div>
                            <div className="teilnahmebedingungen-btn">
                                <button className="mam-rnd-btn">{props.challengeValues.challenge_cta}</button>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="app-view-right mb-md">
                    <div className="detailview-legend-container">

                        <ChallengeLegend legendItems={detailViewLegendItems} />

                        <div className="legend-footnote">
                            <p>* Systemnachricht (nicht änderbar)</p>
                            <div className="legend-container">
                                <strong>Legende:</strong>
                                <div className="legend-box">

                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALNAME}`} </div>
                                        <span className="legend-meaning">{`Name of challenge | Challengename`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALSTARTCD}`}</div>
                                        <span className="legend-meaning">{`Time left (in days) until the challenge starts | Verbleibende Zeit (in Tagen) bis zum Start der Challenge`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALENDCD}`}</div>
                                        <span className="legend-meaning">{`Time left (in days) until the challenge ends | Verbleibende Zeit (in Tagen) bis zum Ende der Challenge`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALREW}`}</div>
                                        <span className="legend-meaning">{`Total reward amount | maximal erreichbare Incentivehöhe`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{USERTASKGOAL}`}</div>
                                        <span className="legend-meaning">{`Activity target for the member | Aktivitätsziel für den Teilnehmer`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">
                                            {`{ACTPROG} or {CHALENPROG}`}
                                        </div>
                                        <span className="legend-meaning">{`Progress of challenge | Challengefortschritt`}</span>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    const renderTeilnahmebedingungen = (
        <div className="app-spacers">
            <div className="app-view mb-md">
                <div className="teilnahmebedingungen-container">
                    <div className="teilnahmebedingungen-text-container">
                        <div className="teilnahmebedingungen-title">{props.challengeValues["challenge_terms-conditions-headline"]}</div>
                        {props.challengeValues["challenge_terms-conditions-copy"] ? (<div className="teilnahmebedingungen-copy">
                            <ReactMarkdown {...MarkdownHelper.allTypes()}
                                source={MarkdownHelper.parse(props.challengeValues["challenge_terms-conditions-copy"])}
                                escapeHtml={false} />
                        </div>) : null}
                    </div>
                </div>
            </div>
        </div>
    )

    const renderChallengeSuccessOverlays = (
        <div className="app-spacers">
            <h2 className="component-headline">Challenge Success Overlay</h2>
            <div className="success-overlays-view">
                <div className="app-view mb-md">
                    <div className="success-overlays-img-container">
                        <img className="img-fluid" src={badge} alt="" />
                        <div className="success-overlays-img-headline">
                            <h2>
                                <ReactMarkdown {...MarkdownHelper.headingTypes()} source={MarkdownHelper.parse(props.challengeValues.challenge_name)} />
                            </h2>
                        </div>
                        <div className="success-overlays-img-text-container">
                            {handleSuccessText()}
                        </div>
                        <div className="success-overlays-teaser-img-container">
                            <img className="success-overlays-teaser-img-logo" src={props.challengeValues["challenge_icon-link"]} alt="" />
                        </div>
                    </div>
                </div>
                <div className="app-view-right mb-md">
                    <div className="success-overlays-legend-container">

                        <ChallengeLegend legendItems={successOverlaysLegendItems} />

                        <div className="legend-footnote">
                            <p>* Systemnachricht (nicht änderbar)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    const renderChallengePushNotifications = (
        <div className="app-spacers">
            <h2 className="component-headline">Push Notification</h2>
            <div className="pushnotifications-view">
                <div className="app-view mb-md">
                    <div className="pushnotifications-img-container">
                        <img className="img-fluid" src={push_bg} alt="" />
                        <div className="pushnotifications-img-title">
                            {<p>{props.challengeValues["challenge_name"]}</p>}
                        </div>
                        <div className="pushnotifications-img-text">
                            {<p>{props.challengeValues["challenge_notification-new-challenge-available"]}</p>}
                        </div>
                    </div>
                </div>
                <div className="app-view-right mb-md">
                    <div className="pushnotifications-legend-container">

                        <ChallengeLegend legendItems={pushnotificationsLegendItems} />

                        <div className="legend-footnote">
                            <p>* Systemnachricht (nicht änderbar)</p>
                            <div className="legend-container">
                                <strong>Legende:</strong>
                                <div className="legend-box">

                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALNAME}`} </div>
                                        <span className="legend-meaning">{`Name of challenge | Challengename`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALSTARTCD}`}</div>
                                        <span className="legend-meaning">{`Time left (in days) until the challenge starts | Verbleibende Zeit (in Tagen) bis zum Start der Challenge`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALENDCD}`}</div>
                                        <span className="legend-meaning">{`Time left (in days) until the challenge ends | Verbleibende Zeit (in Tagen) bis zum Ende der Challenge`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{CHALREW}`}</div>
                                        <span className="legend-meaning">{`Total reward amount | maximal erreichbare Incentivehöhe`}</span>
                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">{`{USERTASKGOAL}`}</div>
                                        <span className="legend-meaning">{`Activity target for the member | Aktivitätsziel für den Teilnehmer`}</span>

                                    </div>
                                    <div className="legend-title-container">
                                        <div className="legend-name">
                                            {`{ACTPROG} or {CHALENPROG}`}
                                        </div>
                                        <span className="legend-meaning">{`Progress of challenge | Challengefortschritt`}</span>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    /* Helper functions */

    function handleSuccessText() {
        let successText = props.challengeValues["challenge-success-text"];

        if (successText !== null && successText.includes('!')) {
            let firstExclamationPoint = successText.indexOf("!");
            let firstPart = successText.substr(0, firstExclamationPoint);
            let secondPart = successText.substr(firstExclamationPoint + 1)

            return (
                <div>
                    <strong className="success-overlays-bestanden">{firstPart}!</strong>
                    <p className="success-overlays-img-text">{secondPart}</p>
                </div>
            );
        } else {
            return (
                <div>
                    <p className="success-overlays-img-text">{successText}</p>
                </div>
            )
        }
    }

    const renderAppChallengeCenter = (
        <div className="">
            {renderChallengeTeaser}
            <hr />
            {renderChallengeDetailView}
            <hr />
            {renderTeilnahmebedingungen}
            <hr />
            {renderChallengeSuccessOverlays}
            <hr />
            {renderChallengePushNotifications}
        </div>
    )

    return (<div className="app-type">
        <div className="">
            {renderAppChallengeCenter}
        </div>
    </div>
    )
};

export default AppChallengeCenter;


// WEBPACK FOOTER //
// ./src/components/ads/app/appchallengecenter/AppChallengeCenter.js